<div class="w-100" fxLayout fxLayoutAlign="center center"
     fxLayoutAlign.lt-lg="center start" ngClass.lt-lg="px-5" [style.height.px]="mediator.contentHeight">
  <router-outlet></router-outlet>
</div>
